export default {
	quickStartTitle: "Quick Start",
	quickStartDescription: [
		"<p>Add a meeting link to have Opre Assistant capture and summarize your notes for you.</p>",
		"<p>You’ll still be able to add your own, collaborative notes and outcomes.</p>",
	].join( "" ),

	planAheadTitle: "Plan Ahead",
	planAheadDescription: "<p>Schedule your one-time or recurring meetings so Opre Assistant automatically joins, then add a best-practice template or create your own agenda.</p>",

	orLabel: "or",
	takeNotesButtonText: "Take notes for me",
	scheduleMeetingsText: "Schedule meetings",
};
